require('./notification.scss');

const NotifySystem = require('react-notification-system');
const React = require('react');
const PropTypes = require('prop-types');
const {Component} = require('react');
const {connect} = require('react-redux');
const { bindActionCreators } = require('redux');
const { OKLink } = require('commonsComponents/OKLink');
const { hide, showed } = require('actions/notifications');
const merge = require('lodash/object/merge');
const get = require('lodash/object/get');

/**
 * Add proper custom style content.
 * @param value The custom props that came from the consumer.
 * @returns {Object}
 */
function _decorateContent(value) {
    const message = get(value, 'opts.message', '');
    const actionText = get(value, 'opts.actionText') || '';
    const actionLink = get(value, 'opts.actionLink') || '';
    const actionClickCallback = get(value, 'opts.actionClickCallback');

    let duration = (message.length + actionText.length) < 50 ? 4 : 6;
    if (!!actionText) {
        duration += 2;
    }

    const iconTypes = {
        alert: 'advertencia',
        success: 'exito',
        error: 'agregar'
    }
    const messageIcon = iconTypes[value.level] || 'advertencia';

    function handleClickCallBack() {
        if (typeof actionClickCallback === 'function') {
            actionClickCallback();
        }
    }

    let action;
    if (!!actionText) {
        action = (
            <div className="custom-notification__action">
                <OKLink to={actionLink} onClick={handleClickCallBack}>
                    {actionText}
                </OKLink>
            </div>
        );
    }

    return {
        level: get(value, 'level', 'success'),
        position: get(value, 'opts.position', 'bc'),
        autoDismiss: get(value, 'opts.autoDismiss', duration),
        dismissible: get(value, 'opts.dismissible', false),
        message: `<div class="custom-notification"><i class="custom-notification__icon icon-${messageIcon}"></i><span class="custom-notification__content">${message}</span></div>`,
        children: action,
    }
}

class Notifications extends Component {
    constructor(props) {
        super(props);
        this._ref = this._ref.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const immNotifications = nextProps.notifications.get('notifications');
        if (immNotifications.size) {
            const notifications = immNotifications.filter(notification => {
                return notification.showed === false
            })
            if(notifications.size) {
                const notification = notifications.first()
                this.el.addNotification(merge(
                    _decorateContent(notification),
                    {
                        onAdd: function () {
                            this.el.clearNotifications();
                            this.props.showed(notification.uid);
                        }.bind(this),
                        // Jero: I don't use arrow functions here in order to
                        // be able to use hide action (that live outside
                        // of the context of the component that was invoke `onRemove` method).
                        onRemove: function () {
                            this.props.hide(notification.uid);
                        }.bind(this)
                    }
                ));
            }
        }
    }

    shouldComponentUpdate(nextProps) {
        return this.props !== nextProps;
    }

    _ref(ref) {
        this.el = ref;
    }

    render() {
        const _resetThemeModal = {
            borderTop: 'none',
            backgroundColor: '#F1F4F4',
            boxShadow: '0 8px 20px 0 rgba(0, 43, 69, .25), 0 1px 4px 0 rgba(0, 43, 69, .15)', // layer-8
        };

        return (
            <NotifySystem
                className="custom-notification"
                allowHTML={true}
                style={{
                    Containers: {
                        DefaultStyle: {
                            margin: '0 auto', //this props is not working
                            left: '0',
                            right: '0',
                            padding: '0px',
                            textAlign: 'center',
                        },
                    },
                    NotificationItem: {
                        alert: _resetThemeModal,
                        error: _resetThemeModal,
                        info: _resetThemeModal,
                        success: _resetThemeModal,
                        warning: _resetThemeModal,
                        DefaultStyle: {
                            width: 'fit-content',
                            height: 'auto', //this prop is not working
                            margin: '0 auto 20px',
                            padding: '16px',
                            borderRadius: '2px',
                        }
                    },
                    MessageWrapper: {
                        DefaultStyle: {
                            display: 'inline-block',
                        }
                    },
                }}
                ref={this._ref}
            />
        );
    }
}

Notifications.propTypes = {
    notifications: PropTypes.object,
    hide: PropTypes.func,
    showed: PropTypes.func,
};

module.exports.constructor = Notifications;
module.exports.Notifications = connect(
        state => ({
        notifications: state.okNotifications
    }),
        dispatch => ({
        hide: bindActionCreators(hide, dispatch),
        showed: bindActionCreators(showed, dispatch),
    })
)(Notifications);
